import script from "./MoveVideosModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoveVideosModal.vue?vue&type=script&setup=true&lang=ts"

import "./MoveVideosModal.vue?vue&type=style&index=0&id=09640ecd&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09640ecd"]])

export default __exports__